import { useLocation } from 'react-router-dom';
import { Button } from '../input';

export const LeftNav = ({ children }) => {
  const location = useLocation();

  const style = {
    width: '100%',
    justifyContent: 'flex-start',
    padding: '8px 16px',
  };

  const button = (path, text) => {
    const shared = {
      style,
      to: path,
    };
    if (location.pathname == path) {
      return (
        <Button grayFlat {...shared}>
          {text}
        </Button>
      );
    } else {
      return (
        <Button trans gray {...shared}>
          {text}
        </Button>
      );
    }
  };

  return (
    <div style={{ display: 'flex', alignItems: 'flex-start', gap: 20 }}>
      <div style={{ width: 140 }}>
        {button('/dashboard', 'Dashboard')}
        {button('/quick-start', 'Quick start')}
        {button('/new', 'New job')}
        {button('/jobs', 'Jobs')}
        {button('/billing', 'Billing')}
      </div>
      <div style={{ flex: 1, minWidth: 0, marginRight: 10 }}>{children}</div>
    </div>
  );
};
